export default __webpack_public_path__ + "static/NavRingOuter-848856f2d970a2083ee4e54eda97dcb4.png";